import React from "react";
import { PaymentTypeOptions } from "utils/Constant";
import { money, DateFormat } from "utils/helpers";

function SalesDetailTable({ rows, total, count }) {
  return (
    <div className="max-h-[300px] overflow-y-auto rounded-xl border border-gray-100 bg-white p-4 shadow-sm">
      <div className="mb-3 flex items-center justify-between">
        <div className="flex gap-3 items-center">
          <h3 className="text-sm font-semibold text-gray-700">Sales Detail</h3>
        </div>
        
        <span className="text-xs text-gray-400">{count} items</span>
      </div>

      <table className="w-full text-xs">
        <thead>
          <tr className="text-left text-gray-400">
            <th className="pb-2">Order Id</th>
            <th className="pb-2">Date</th>
            <th className="pb-2">Customer</th>
            <th className="pb-2">Product</th>
            <th className="pb-2 text-right">Qty</th>
            <th className="pb-2 text-right">Total</th>
            <th className="pb-2 text-right">Method</th>
          </tr>
        </thead>

        <tbody className="divide-y divide-gray-50">
          {rows?.map((row) => (
            <tr key={row.orderId}>
              <td className="py-2 font-medium text-gray-700">
                {row.orderId}
              </td>
              <td className="py-2 text-gray-500">{DateFormat(row.date)}</td>
              <td className="py-2 text-gray-700">{row.customer}</td>
              <td className="py-2 text-gray-700">{row.product}</td>
              <td className="py-2 text-right text-gray-700">{row.qty}</td>
              <td className="py-2 text-right font-medium text-gray-900">
                {money(row.total)}
              </td>
              <td className="py-2 text-gray-500  text-right">
                <span
                  className={`rounded-full px-2 py-0.5 text-[10px] font-medium bg-blue-50 text-amber-600"}`}
                >
                  {PaymentTypeOptions.find(x => x.value === String(row.paymentMethod)).label}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="mt-3 flex justify-between border-t border-gray-100 pt-2 text-xs font-semibold text-gray-700">
        <span>Total Sales</span>
        <span>{money(total)}</span>
      </div>
    </div>
  );
}

function RentalDetailTable({ rows, total, count }) {
  return (
    <div className="max-h-[300px] overflow-y-auto rounded-xl border border-gray-100 bg-white p-4 shadow-sm">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="text-sm font-semibold text-gray-700">Rental Detail</h3>
        <span className="text-xs text-gray-400">{count} transactions</span>
      </div>

      <table className="w-full text-xs">
        <thead>
          <tr className="text-left text-gray-400">
            <th className="pb-2">Rental Order Id</th>
            <th className="pb-2">Customer</th>
            <th className="pb-2">Racket</th>
            <th className="pb-2">Out</th>
            <th className="pb-2">Return</th>
            <th className="pb-2 text-right">Days</th>
            <th className="pb-2 text-right">Total</th>
          </tr>
        </thead>

        <tbody className="divide-y divide-gray-50">
          {rows?.map((row) => (
            <tr key={row.orderId}>
              <td className="py-2 font-medium text-gray-700">
                {row.orderId}
              </td>
              <td className="py-2 text-gray-700">{row.customer}</td>
              <td className="py-2 text-gray-700">{row.racket}</td>
              <td className="py-2 text-gray-500">
                {DateFormat(row.checkoutDate)}
              </td>
              <td className="py-2 text-gray-500">
                {DateFormat(row.returnDate)}
              </td>
              <td className="py-2 text-right text-gray-700">{row.days}</td>
              <td className="py-2 text-right font-medium text-gray-900">
                {money(row.total)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="mt-3 flex justify-between border-t border-gray-100 pt-2 text-xs font-semibold text-gray-700">
        <span>Total Rental</span>
        <span>{money(total)}</span>
      </div>
    </div>
  );
}

function RentalSummaryCard({ summary }) {
  const rows = [
    ["Total Rentals", summary?.totalRentals],
    ["Total Rental Days", summary?.totalRentalDays],
    ["Rental Revenue", money(summary?.rentalRevenue)],
    // ["Deposit Received", money(summary?.depositReceived)],
    // ["Deposit Returned", money(summary?.depositReturned)],
    // ["Late Fee", money(summary?.lateFee)],
    // ["Damage Fee", money(summary?.damageFee)],
  ];

  return (
    <div className="rounded-xl border border-gray-100 bg-white p-4 shadow-sm">
      <h3 className="mb-3 text-sm font-semibold text-gray-700">
        Rental Summary
      </h3>

      <div className="space-y-2 text-xs">
        {rows.map(([label, value]) => (
          <div key={label} className="flex justify-between text-gray-600">
            <span>{label}</span>
            <span className="font-medium text-gray-900">{value}</span>
          </div>
        ))}
      </div>

      {/* <div className="mt-3 flex justify-between border-t border-gray-100 pt-2 text-xs font-semibold text-red-500">
        <span>Total Fee</span>
        <span>{money(summary?.totalFee)}</span>
      </div> */}
    </div>
  );
}

export default function DetailTables({ data, loading, error }) {
  if (error) {
    return (
      <div className="rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-600">
        {error}
      </div>
    );
  }

  if (loading) {
    return (
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="h-64 animate-pulse rounded-xl bg-gray-100" />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-1">
      <div className="lg:col-span-1">
        <SalesDetailTable
          rows={data?.salesDetail}
          total={data?.totalSales}
          count={data?.totalSalesItems}
        />
      </div>

      <div className="lg:col-span-1">
        <RentalDetailTable
          rows={data?.rentalDetail}
          total={data?.totalRental}
          count={data?.totalRentalTransactions}
        />
      </div>

      <div className="lg:col-span-1">
        <RentalSummaryCard summary={data?.rentalSummary} />
      </div>
    </div>
  );
}
